import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { Traffics } from "../../../Constant";
import { H5, LI, UL } from "../../../AbstractElements";
import { TRAFIC_CHART_DATA, TRAFIIC_DATA } from "../../../Data/Dashboard";
import ReactApexChart from "react-apexcharts";

const Traffic = () => {
  return (
    <Col xl="4" sm="12" md="6" className="box-col-4e">
      <Card>
        <CommonCardHeader title={Traffics} className="card-no-border" />
        <CardBody className="p-0">
          <UL className="traffic-list simple-list d-flex flex-row">
            {TRAFIIC_DATA.map((item, index) => (
              <LI key={index}>
                <div>
                  <H5>{item.amount}</H5>
                  <div className="d-flex gap-1 align-items-center">
                    <div className={`user-box ${item.iconClass}`}><i className={`fa fa-${item.icon} ms-2`}> </i></div>
                    <span className="f-w-500"><strong className={item.colorClass ? item.colorClass : ""}>+45% </strong></span>
                    {item.span}
                  </div>
                </div>
              </LI>
            ))}
          </UL>
          <div className="traffic-chart" id="traffic">
            <ReactApexChart options={TRAFIC_CHART_DATA} series={TRAFIC_CHART_DATA.series} type="area" height={235} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Traffic;
